exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3P2TDzTB8GXqfPgqEENM5V {\n    position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"recordingContent": "_3P2TDzTB8GXqfPgqEENM5V"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/EkgRecordingDetails/EkgRecordingDetails.css
// module id = 10372
// module chunks = 23